import { render } from "./OrderCommentCreateEditDialog.vue?vue&type=template&id=c2a190a4&scoped=true&ts=true"
import script from "./OrderCommentCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./OrderCommentCreateEditDialog.vue?vue&type=script&lang=ts"

import "./OrderCommentCreateEditDialog.vue?vue&type=style&index=0&id=c2a190a4&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a190a4"]])

export default __exports__